if(document.querySelector(".selector-wrapper")) {
  document.querySelector(".selector-wrapper").innerHTML += `<div id="radio-buttons-container"></div>`;
  
  var selectElement = document.getElementById("option-formula");
  
  var radioButtonsContainer = document.getElementById("radio-buttons-container");
  function updateSelection(event) {
    selectElement.selectedIndex = event.target.value;
    document.querySelector('.pretty-select .text').textContent = event.target.dataset.name;
  }
  
  for (var i = 0; i < selectElement.options.length; i++) {
    var option = selectElement.options[i];  
    var radioButton = document.createElement("input");
    radioButton.type = "radio";
    radioButton.name = "colorOption";
  
    radioButton.value = i;
    radioButton.id = "radio-" + i;
    radioButton.dataset.id = option.classList.value;
    radioButton.dataset.img = option.dataset.img;
    radioButton.dataset.name = option.textContent.trim().replace(/\n/g, '');
    radioButton.addEventListener("click", updateSelection);
  
    var label = document.createElement("label");
    label.htmlFor = "radio-" + i;
    label.classList.add("r-" + removeSpecialCharactersAndSpaces(option.value));
    label.innerHTML = '<svg fill="#7F5330" class="radio-svg" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="11.998" cy="11.998" fill-rule="nonzero" r="9.998"></circle><circle class="check-circle" cx="11.998" cy="11.998" r="5" fill="#007bff" opacity="0"></circle></svg>';
  
    radioButtonsContainer.appendChild(radioButton);
    radioButtonsContainer.appendChild(label);
  }

  function removeSpecialCharactersAndSpaces(inputString) {
    let cleanedString = inputString.replace(/[^a-zA-Z0-9\s]/g, '');
    cleanedString = cleanedString.replace(/\s/g, '-');
    return cleanedString.toLowerCase();
  }

  if(document.querySelector("#shopify-section-template--15529567355016__5733edb3-23a6-49d2-8d02-56f3b8165d28 p")) {
    const lines = document.querySelector("#shopify-section-template--15529567355016__5733edb3-23a6-49d2-8d02-56f3b8165d28 p").textContent.trim().split('\n');
    const styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    
    for (const line of lines) {
      const [selector, color] = line.split(':');
      if (selector && color) {
        const cssRule = `.r-${removeSpecialCharactersAndSpaces(selector.trim())} svg {\n fill: ${color.trim()}\n}\n`;
        const cssTextNode = document.createTextNode(cssRule);
        styleElement.appendChild(cssTextNode);
      }
    }
    
    document.head.appendChild(styleElement);
  }

  if(document.querySelector("#shopify-section-template--15529567322248__8aad2952-b002-4864-9540-33b7c0c5c179 p")) {
    const lines = document.querySelector("#shopify-section-template--15529567322248__8aad2952-b002-4864-9540-33b7c0c5c179 p").textContent.trim().split('\n');
    const styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    
    for (const line of lines) {
      const [selector, color] = line.split(':');
      if (selector && color) {
        const cssRule = `.r-${removeSpecialCharactersAndSpaces(selector.trim())} svg {\n fill: ${color.trim()}\n}\n`;
        const cssTextNode = document.createTextNode(cssRule);
        styleElement.appendChild(cssTextNode);
      }
    }
    
    document.head.appendChild(styleElement);
  }
}

window.onload = function() {
  if(document.querySelector(".slick-next")) {
    document.querySelector(".slick-next").addEventListener("click", () => {
        let id = document.querySelector(".thumbnail.active img").alt;
        let selectElement = document.querySelector('select#option-formula');
        let optionToSelect = selectElement.querySelector(`option[data-img="${id}"]`);
        document.querySelector(`input[type="radio"][data-img="${id}"]`).click();
        if (optionToSelect) {
          selectElement.value = optionToSelect.value;
        }
    });
  
    document.querySelector(".slick-prev").addEventListener("click", () => {
      let id = document.querySelector(".thumbnail.active img").alt;
      let selectElement = document.querySelector('select#option-formula');
      let optionToSelect = selectElement.querySelector(`option[data-img="${id}"]`);
      
      document.querySelector(`input[type="radio"][data-img="${id}"]`).click();
        if (optionToSelect) {
          selectElement.value = optionToSelect.value;
      }
    });

    document.querySelectorAll(".thumbnail img").forEach(e => {
       e.addEventListener("click", (e) => {
          let id = e.target.alt;
          let selectElement = document.querySelector('select#option-formula');
          let optionToSelect = selectElement.querySelector(`option[data-img="${id}"]`);
          
          document.querySelector(`input[type="radio"][data-img="${id}"]`).click();
            if (optionToSelect) {
              selectElement.value = optionToSelect.value;
          }
       });
    });

    document.querySelector("#option-formula").addEventListener("change", (e) => {
     let id = e.target.options[e.target.selectedIndex].getAttribute("data-img");
      document.querySelector(`input[type="radio"][data-img="${id}"]`).click();
    });
    
  }
}


function tryOnBtn() {
  const url = "https://smb-api.makeupar.com/smb-api/query-product-summary.action?apiKey=SMB-Ojo6NDY4MjY=";
  fetch(url)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    data.skus.forEach((element, index) => {
      console.log('ref-' + element.skuNo);
      if(document.querySelector('.ref-' + element.skuNo)) {
        document.querySelector('.ref-' + element.skuNo).innerHTML = `<button class="YMK-btn" refId="${element.skuNo}">Try On</button>`;
      }
    });
  })
  .catch(error => {
    console.error('Fetch error:', error);
  });
}
tryOnBtn();

// function helpers
function getSKU(target_sku) {
  const SMB_URL = 'https://smb-api.makeupar.com/smb-api/query-product-summary.action?apiKey=SMB-Ojo6NDY4MjY=';
  fetch(SMB_URL)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log(target_sku);
      console.log(data.skus.find(v => v.skuName == target_sku));
      let sku = data.skus.find(v => v.skuName == target_sku).skuNo;
      console.log(sku);
      getProductID(sku);
    })
}
function getProductID(skuToFind) {
  // fetch('/products.json')
  //   .then(function(response) {
  //     return response.json();
  //   })
  //   .then(function(data) {
  //     var variantId = null;
  //     data.products.forEach(function(product) {
  //       product.variants.forEach(function(variant) {
  //         if (variant.sku === skuToFind) {
  //           variantId = variant.id;
  //         }
  //       });
  //     });
  
  //     if (variantId) {
  //       console.log('Variant ID:', variantId);
  //       addToCart(variantId);
  //     } else {
  //       alert('SKU not found in Shopify Products');
  //     }
  //   })
  //   .catch(function(error) {
  //     console.error('Error:', error);
  //   });

  let currentPage = 1;

  function searchSKUInProducts() {
    const url = `/products.json?page=${currentPage}`;
    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log(data.products.length);
        var variantId = null;
  
        data.products.forEach(function (product) {
          product.variants.forEach(function (variant) {
            if (variant.sku === skuToFind) {
              variantId = variant.id;
            }
          });
        });
  
        if (variantId) {
          console.log('Variant ID:', variantId);
          addToCart(variantId);
        } else {
          if (data.products.length === 0) {
            return;
          }
          currentPage++;
          searchSKUInProducts();
        }
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
  }

  searchSKUInProducts();
}

function addToCart(sku) {
  var item = {
    quantity: 1,
    id: sku,
  };
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(item),
  })
    .then(function(response) {
      theme.updateCartSummaries(true,true);
      let iframe = document.getElementById("YMK-module-iframe");
      let iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      iframeDocument.querySelector(".addtocart").innerHTML = "Add To Cart";
    })
    .then(function(data) {
      console.log(data);
    })
}


window.ymkAsyncInit = function () {
   YMK.init();
   YMK.addEventListener('loaded', function (e) {
      let iframe = document.getElementById("YMK-module-iframe");
      let iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      let elementInIframe = iframeDocument.querySelector(".slick-track");

      iframeDocument.querySelector("#Product").insertAdjacentHTML('afterend', `<div class='addtocart' data-sku="" data-name="" style='cursor:pointer;position:absolute;bottom:10px;right:10px;background-color:#413354;padding:15px;color:#fff;border-radius:25px;font-size:15px;'>Add To Cart</div>`);

      iframeDocument.querySelector(".addtocart").addEventListener("click", (e) => {
        iframeDocument.querySelector(".addtocart").innerHTML = `<style>@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }}</style><div class="loader" style="border: 2px solid #f3f3f3; border-top: 2px solid #3498db; border-radius: 50%; width: 10px; height: 10px; animation: spin 2s linear infinite;"></div>`;
        getSKU(e.target.dataset.name);
      });
     
      // const observer = new MutationObserver(callback);
      // function callback(mutationsList, observer) {
      //    for (const mutation of mutationsList) {
      //       if (mutation.type === 'childList') {
      //          console.log('this is a tset');
      //       } else if (mutation.type === 'attributes') {
      //           const data = iframeDocument.querySelector("#Product");
      //           const data1 = iframeDocument.querySelector(".addtocart").dataset.sku = data.querySelector('div[style*="font-weight: bold"]').textContent;
      //           const data2 = iframeDocument.querySelector(".addtocart").dataset.name = data.querySelector('div[style*="font-weight: normal"]').textContent;
      //           console.log(data, data1, data2);
      //       }
      //    }
      // }

      // const config = {
      //    attributes: true,
      //    childList: true,
      //    subtree: true
      // };

      const slickTrackElements = Array.from(iframeDocument.querySelectorAll(".slick-track"));
      
      const config = {
        attributes: true,
        childList: true,
        subtree: true,
      };
      
      slickTrackElements.forEach(element => {
        const observer = new MutationObserver(callback);
      
        function callback(mutationsList, observer) {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              console.log('This is a test');
            } else if (mutation.type === 'attributes') {
              const data = iframeDocument.querySelector("#Product");
              const data1 = iframeDocument.querySelector(".addtocart").dataset.sku = data.querySelector('div[style*="font-weight: bold"]').textContent;
              const data2 = iframeDocument.querySelector(".addtocart").dataset.name = data.querySelector('div[style*="font-weight: normal"]').textContent;
              console.log(data, data1, data2);
            }
          }
        }
      
        observer.observe(element, config);
      });
   })
}